import React from 'react'
import { Hooks } from 'hooks'
import { LayoutMain } from 'layouts/Main'
import { LayoutPlayer } from 'layouts/Player'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

export const App = (props) => {
  return (
    <Router>
      <Hooks>
        <Switch>
          <Route path='/creator'>
            <LayoutMain/>
          </Route>
          <Route path='/player'>
            <LayoutPlayer/>
          </Route>
          <Route path='/'>
            <LayoutMain/>
          </Route>
        </Switch>
      </Hooks>
    </Router>
  )
}
